import WIDGETS from './widgets';

export default {
	name: 'broadcast_message_input',
	spacing: 2,
	sx: { width: '100%', margin: '0px' },
	widgets: [
		{
			content: WIDGETS.BROADCAST_MESSAGE_INPUT,
			breakpoints: { xs: 12, sm: 12 },
			lazy_loading: 0,
			grid_props: {
				sx: { padding: '0px' },
			},
		},
	],
};
